var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-locale-provider", { attrs: { locale: _vm.zh_CN } }, [
    [
      "/monitoringReport",
      "/monitoringDetails",
      "/trademarkNameReviewReport",
      "/monitorSubscriptionAdmin",
      "/reviewOpinions/choosePlan",
      "/userAgreement",
      "/privacyPolicy",
      "/payment"
    ].includes(_vm.$route.path)
      ? _c("div", { attrs: { id: "app" } }, [_c("router-view")], 1)
      : _c(
          "div",
          {
            class: {
              cjtclient: _vm.PROCESS_ENV.NODE_PLA === "kby",
              wgclient: _vm.PROCESS_ENV.NODE_PLA === "wg",
              "login-container":
                _vm.curUrl == "/login" || _vm.$route.path == "/"
            },
            attrs: { id: "app" }
          },
          [
            ((_vm.ishfShow && _vm.ifLogin) || _vm.curUrl) &&
            _vm.curUrl !== "/login"
              ? _c("HeaderNew")
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                class:
                  _vm.appClass ||
                  ["/monitoringSubscription"].includes(_vm.curUrl)
                    ? "app-container"
                    : ""
              },
              [
                _c(
                  "div",
                  {
                    class: {
                      "app-content-m0": [
                        "/payment",
                        "/paymentSuccess"
                      ].includes(_vm.curUrl),
                      "app-content-wrap": _vm.leftShow,
                      "product-wrapper": _vm.isProductDetail && !_vm.leftShow
                    }
                  },
                  [
                    _c("router-view"),
                    _vm._v(" "),
                    _vm.ifLogin &&
                    _vm.ishfShow &&
                    !["/payment", "/paymentSuccess"].includes(_vm.curUrl)
                      ? _c("Footer")
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.leftShow &&
                ![
                  "/payment",
                  "/paymentSuccess",
                  "/monitoringSubscription"
                ].includes(_vm.curUrl) &&
                _vm.$route.path !== "/"
                  ? _c("MenuLeft")
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isEmbed ? _c("SideService") : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "Modal",
              {
                attrs: { width: "416px", closable: false },
                on: {
                  "on-ok": function($event) {
                    _vm.sfcVisible = false
                  },
                  "on-cancel": function($event) {
                    _vm.sfcVisible = false
                  }
                },
                model: {
                  value: _vm.sfcVisible,
                  callback: function($$v) {
                    _vm.sfcVisible = $$v
                  },
                  expression: "sfcVisible"
                }
              },
              [
                _vm._l(_vm.sfc, function(item, index) {
                  return _c("div", { key: index }, [
                    item.value.includes("http")
                      ? _c("img", {
                          staticClass: "sfc-img",
                          attrs: { src: item.value }
                        })
                      : _c("p", [_vm._v(_vm._s(item.value))])
                  ])
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "sfc-mt10",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "Button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.sfcVisible = false
                          }
                        }
                      },
                      [_vm._v("关闭")]
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { attrs: { id: "box" } })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 